































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import QDatePicker from '@/components/Booking/QDatePicker.vue';

@Component({
  components: {
    QDatePicker,
  },
  computed: {
    ...mapState('ServiceItem', {
      serviceItems: 'serviceItems',
    }),
    ...mapState('Business', {
      allBusinesses: 'allBusinesses',
    }),
  },
})
export default class ServicePaymentReport extends Vue {
  isMounted = false;
  loading = false;
  serviceItems!: Model[];
  allBusinesses!: Model[];
  businessOid = null;
  serviceItemOid = null;
  startDate = null;
  endDate = null;
  excludeBusinessOids = [];

  isApiFetch = {
    isApiFetchServiceItemsFinished: false,
    isApiFetchBusinesssFinished: false,
  };

  async beforeMount() {
    if (!this.serviceItems.length) {
      await this.$store.dispatch('ServiceItem/fetchList');
    }
    this.isApiFetch['isApiFetchServiceItemsFinished'] =
      this.serviceItems.length > 0;

    if (!this.allBusinesses.length) {
      await this.$store.dispatch('Business/all');
    }
    this.isApiFetch['isApiFetchBusinesssFinished'] =
      this.allBusinesses.length > 0;
  }

  @Watch('isApiFetch', { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true;
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false;
        }
      }

      if (!isFinished) {
        return;
      }
      this.isMounted = true;
    }
  }

  download() {
    this.loading = true;
    this.$store
      .dispatch('ServicePayment/report', {
        params: {
          start_date: this.startDate,
          end_date: this.endDate,
          business_oid: this.businessOid,
          service_item_oid: this.serviceItemOid,
          exclude_business_oids: this.excludeBusinessOids,
        },
      })
      .then((response) => {
        const blob = new Blob([response.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'Financial Report';
        link.click();
        // URL.revokeObjectURL(link.href)
        this.loading = false;
        // this.$vs.loading.close('#download-pdf > .con-vs-loading')
      });
  }
}
